/* eslint-disable no-shadow */

import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";

import Breadcrumbs from "../Breadcrumbs";

interface Props {}

const AutoBreadcrumbs: React.FC<Props> = () => {
	const { t } = useTranslation();
	const { pathname } = useLocation();

	const items = useMemo(() => {
		let path = "";

		const items = pathname
			.split(/\/+/)
			.filter((item) => !!item)
			.map((item) => ({
				label: t([`routes.${item}`, item]),
				link: (path += `/${item}`),
			}));

		items.unshift({
			label: t([`routes.main`, "main"]),
			link: "/",
		});

		return items;
	}, [pathname, t]);

	return <Breadcrumbs items={items} />;
};

export default AutoBreadcrumbs;
